import React, { PropsWithChildren } from 'react';
import { clsx } from 'clsx';
import { Colors } from '@common/tokens';
import { VerticalStep, VERTICAL_STEP_STATUSES } from './_vertical-step';

type Props = {
  className?: string;
};

export const VerticalSteps = ({
  children,
  className,
}: PropsWithChildren<Props>) => (
  <>
    <ul className={clsx('wk-vertical-steps', className)}>{children}</ul>
    <style jsx>{`
      .wk-vertical-steps {
        margin: 0;
        padding: 0;
      }
      .wk-vertical-steps :global(.wk-vertical-step + .wk-vertical-step) {
        margin-top: 16px;
      }
      .wk-vertical-steps :global(.wk-vertical-step + .wk-vertical-step:before) {
        content: ' ';
        background-color: ${Colors.steel};
        position: absolute;
        width: 4px;
        height: 16px;
        top: -17px;
        left: 25px;
      }
      .wk-vertical-steps
        :global(.wk-vertical-step + .wk-vertical-step--wait:before) {
        background-color: ${VERTICAL_STEP_STATUSES.wait.color};
      }
      .wk-vertical-steps
        :global(.wk-vertical-step + .wk-vertical-step--error:before) {
        background-color: ${VERTICAL_STEP_STATUSES.error.color};
      }
      .wk-vertical-steps
        :global(.wk-vertical-step + .wk-vertical-step--finish:before) {
        background-color: ${VERTICAL_STEP_STATUSES.finish.color};
      }
      .wk-vertical-steps
        :global(.wk-vertical-step + .wk-vertical-step--process:before) {
        background-color: ${VERTICAL_STEP_STATUSES.process.color};
      }
    `}</style>
  </>
);

VerticalSteps.Step = VerticalStep;
